module.exports = __webpack_public_path__ + "img/y-20.de268a1e.png";